import { variables } from '../../../cssInJs';

export default {
  modalOverlay: {
    backgroundColor: 'rgba(0,0,0,0.85)',
    position: 'fixed',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    overflowY: 'auto',
    padding: '2rem 0',
  },
  
  modalContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
  },
  
  modalContent: {
    backgroundColor: 'white',
    borderRadius: '8px',
    padding: '2rem',
    position: 'relative',
  },
  
  closeButton: {
    textAlign: 'right',
    cursor: 'pointer',
    fontWeight: 'bold',
    marginBottom: '1rem',
    color: variables.primaryColor,
    '&:hover': {
      textDecoration: 'underline',
    }
  },
  
  modalTitle: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    marginBottom: '0.5rem',
    color: variables.primaryColor,
  },
  
  productName: {
    fontSize: '1.2rem',
    fontWeight: '600',
    marginBottom: '0.5rem',
    textTransform: 'uppercase',
  },
  
  productDescription: {
    fontSize: '0.9rem',
    color: '#666',
    marginBottom: '1rem',
    fontStyle: 'italic',
  },
  
  instructions: {
    fontSize: '0.9rem',
    marginBottom: '1.5rem',
    color: '#666',
  },
  
  tableSection: {
    marginBottom: '2rem',
  },
  
  tableSectionHeader: {
    backgroundColor: variables.primaryColor,
    color: 'white',
    padding: '0.75rem 1rem',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    marginBottom: '0.5rem',
  },
  
  tableContainer: {
    overflowX: 'auto',
    border: '1px solid #ddd',
    borderTop: 'none',
  },
  
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    'th, td': {
      padding: '0.5rem',
      textAlign: 'center',
      borderRight: '1px solid #ddd',
      verticalAlign: 'middle',
      height: '3rem',
      '&:first-of-type': {
        textAlign: 'left',
        fontWeight: 'bold',
      },
      '&:last-child': {
        borderRight: 'none',
      }
    },
    'thead th': {
      backgroundColor: '#f5f5f5',
      fontWeight: 'bold',
      borderBottom: '2px solid #ddd',
    },
    'tbody tr': {
      borderBottom: '1px solid #ddd',
      '&:last-child': {
        borderBottom: 'none',
      }
    },
  },
  
  totalRow: {
    backgroundColor: '#f5f5f5',
    fontWeight: 'bold',
  },
  
  qtyInput: {
    width: '60px',
    height: '2rem',
    padding: '0.25rem 0.5rem',
    textAlign: 'center',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '0.9rem',
    boxSizing: 'border-box',
    '&:focus': {
      outline: 'none',
      borderColor: variables.primaryColor,
    }
  },
  
  personalisationSection: {
    marginBottom: '2rem',
  },
  
  personalisationForm: {
    padding: '1rem',
    backgroundColor: '#f9f9f9',
    border: '1px solid #ddd',
    borderTop: 'none',
  },
  
  formRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
    gap: '0.5rem',
    alignItems: 'start',
    '@media (max-width: 768px)': {
      gridTemplateColumns: '1fr 1fr',
    },
    '@media (max-width: 480px)': {
      gridTemplateColumns: '1fr',
    },
  },
  
  formField: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '0',
  },
  
  textInput: {
    width: '100%',
    height: '2.5rem',
    padding: '0.5rem',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '0.9rem',
    boxSizing: 'border-box',
    '&:focus': {
      outline: 'none',
      borderColor: variables.primaryColor,
    }
  },
  
  selectInput: {
    width: '100%',
    height: '2.5rem',
    padding: '0.5rem',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '0.9rem',
    backgroundColor: 'white',
    boxSizing: 'border-box',
    '&:focus': {
      outline: 'none',
      borderColor: variables.primaryColor,
    }
  },
  
  qtyInputSmall: {
    width: '100%',
    maxWidth: '100px',
    height: '2.5rem',
    padding: '0.5rem',
    textAlign: 'center',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '0.9rem',
    backgroundColor: 'white',
    boxSizing: 'border-box',
    '&:focus': {
      outline: 'none',
      borderColor: variables.primaryColor,
    }
  },
  
  addButton: {
    width: '100%',
    height: '2.5rem',
    padding: '0.5rem 1rem',
    backgroundColor: variables.primaryColor,
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontSize: '0.9rem',
    boxSizing: 'border-box',
    '&:hover': {
      opacity: 0.9,
    }
  },
  
  buttonGroup: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '0.5rem',
    width: '100%',
  },
  
  updateButton: {
    height: '2.5rem',
    padding: '0.5rem 1rem',
    backgroundColor: variables.primaryColor,
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontSize: '0.9rem',
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    '&:hover': {
      opacity: 0.9,
    }
  },
  
  personalisedList: {
    marginTop: '1.5rem',
    'h4': {
      marginBottom: '0.75rem',
      fontSize: '1rem',
    }
  },
  
  personalisedItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.75rem',
    backgroundColor: 'white',
    border: '1px solid #ddd',
    borderRadius: '4px',
    marginBottom: '0.5rem',
    fontSize: '0.9rem',
  },
  
  editButton: {
    padding: '0.4rem 0.8rem',
    backgroundColor: 'transparent',
    color: variables.primaryColor,
    border: `2px solid ${variables.primaryColor}`,
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.8rem',
    marginRight: '0.5rem',
    fontWeight: '500',
    minWidth: '60px',
    '&:hover': {
      backgroundColor: variables.primaryColor,
      color: 'white',
    }
  },
  
  removeButton: {
    padding: '0.4rem 0.8rem',
    backgroundColor: '#dc3545',
    color: 'white',
    border: '2px solid #dc3545',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '0.8rem',
    minWidth: '60px',
    fontWeight: '500',
    '&:hover': {
      opacity: 0.9,
    }
  },
  
  cancelButton: {
    height: '2.5rem',
    padding: '0.5rem 1rem',
    backgroundColor: '#6c757d',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontSize: '0.9rem',
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    '&:hover': {
      opacity: 0.9,
    }
  },
  
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '1.5rem',
    borderTop: '2px solid #ddd',
    flexWrap: 'wrap',
    gap: '1rem',
  },
  
  totalAmount: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  
  actions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '0.5rem',
    'button': {
      minWidth: '200px',
    }
  },
  
  goToCartButton: {
    minWidth: '200px',
    marginTop: '0.5rem',
  },
};

